module.exports = __webpack_public_path__ + "static/media/dashboard_icon_wh_active.e5a7821e.svg";